module.exports = __webpack_public_path__ + "img/MinusBtn.6523845d.svg";